import {
  ENT_SUPPLIER_USER_LIST, ENT_SUPPLIER_USER_LIST_SUCCESS, ENT_SUPPLIER_USER_LIST_ERROR,
  ENT_SUPPLIER_USER_PAGE_SET,
  ENT_SUPPLIER_USER_ADD, ENT_SUPPLIER_USER_ADD_SUCCESS, ENT_SUPPLIER_USER_ADD_ERROR,
  ENT_SUPPLIER_USER_ADD_CHANGE,
  ENT_SUPPLIER_USER_DETAIL, ENT_SUPPLIER_USER_DETAIL_SUCCESS, ENT_SUPPLIER_USER_DETAIL_ERROR,
  ENT_SUPPLIER_USER_UPDATE, ENT_SUPPLIER_USER_UPDATE_SUCCESS, ENT_SUPPLIER_USER_UPDATE_ERROR,
} from '../../actions';

const INIT_STATE = {
  loading: true,
  list: { header: { name: 'Id', order: 'sorted-asc' }, page: { current: 1, rows: 1000 }, data: [], total_pages: 1 },
  detail: { loading: false, data: null },
  add: { data: { new: { Email: '' } }, loading: false, message: '' },
  edit: { update: { loading: false, response: '', message: '' } },
  error: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ENT_SUPPLIER_USER_LIST: return { ...state, loading: true };
    case ENT_SUPPLIER_USER_LIST_SUCCESS: return { ...state, loading: false, list: { ...state.list, ...action.payload } };
    case ENT_SUPPLIER_USER_LIST_ERROR: return { ...state, loading: false, error: true };
    case ENT_SUPPLIER_USER_PAGE_SET: return { ...state, list: { ...state.list, page: { ...state.list.page, ...action.payload } } };
    case ENT_SUPPLIER_USER_ADD_CHANGE: return { ...state, add: { ...state.add, data: { ...state.add.data, new: { ...state.add.data.new, ...action.payload } } } };
    case ENT_SUPPLIER_USER_ADD: return { ...state, add: { ...state.add, loading: true } };
    case ENT_SUPPLIER_USER_ADD_SUCCESS: return { ...state, add: { ...state.add, loading: false, message: action.payload.message, data: { new: { Email: '' } } } };
    case ENT_SUPPLIER_USER_ADD_ERROR: return { ...state, add: { ...state.add, loading: false, message: action.payload.message } };
    case ENT_SUPPLIER_USER_DETAIL: return { ...state, detail: { ...state.detail, loading: true } };
    case ENT_SUPPLIER_USER_DETAIL_SUCCESS: return { ...state, detail: { loading: false, data: action.payload } };
    case ENT_SUPPLIER_USER_DETAIL_ERROR: return { ...state, detail: { loading: false, data: null } };
    case ENT_SUPPLIER_USER_UPDATE: return { ...state, edit: { ...state.edit, update: { loading: true, response: '', message: '' } } };
    case ENT_SUPPLIER_USER_UPDATE_SUCCESS: return { ...state, edit: { ...state.edit, update: { loading: false, response: 'success', message: action.payload } } };
    case ENT_SUPPLIER_USER_UPDATE_ERROR: return { ...state, edit: { ...state.edit, update: { loading: false, response: 'error', message: action.payload } } };
    default: return { ...state };
  }
};
